import { FC } from 'react';
import { Badge, Button, Card, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './portfolio-summary-card.scss';

export type PortfolioSummaryRow = {
  label: string;
  total: number | string;
  active: number | string;
  onboarding: number | string;
  pending: number | string;
};

type PortfolioSummaryCardProps = {
  title: string;
  subtitle: string;
  status: string;
  statusTone: string;
  actionTo: string;
  actionLabel: string;
  rows: PortfolioSummaryRow[];
  readiness?: {
    label: string;
    tone: 'success' | 'warning';
  };
};

const PortfolioSummaryCard: FC<PortfolioSummaryCardProps> = ({
  title,
  subtitle,
  status,
  statusTone,
  actionTo,
  actionLabel,
  rows,
  readiness,
}) => (
  <Card className="custom-card cares-portfolio-card h-100 mb-0">
    <Card.Header className="cares-portfolio-card__header">
      <div className="d-flex align-items-start justify-content-between gap-2">
        <div className="min-w-0 flex-grow-1">
          <div className="d-flex flex-wrap align-items-center gap-1 mb-1">
            <div className="card-title cares-portfolio-card__title mb-0">{title}</div>
            <Badge bg={statusTone} className="cares-portfolio-card__status">{status}</Badge>
          </div>
          <div className="text-muted cares-portfolio-card__subtitle" title={subtitle}>{subtitle}</div>
        </div>
        <Button
          as={Link as any}
          to={actionTo}
          variant="primary-light"
          size="sm"
          className="cares-portfolio-card__action flex-shrink-0"
          aria-label={`${actionLabel}: ${title}`}
        >
          Open
        </Button>
      </div>
      {readiness ? (
        <div className="cares-portfolio-card__readiness">
          <span className={`badge bg-${readiness.tone}-transparent text-${readiness.tone}`}>{readiness.label}</span>
        </div>
      ) : null}
    </Card.Header>
    <Card.Body className="cares-portfolio-card__body">
      <div className="table-responsive border rounded">
        <Table bordered hover size="sm" className="cares-portfolio-card__table mb-0">
          <thead>
            <tr>
              <th scope="col">Resource</th>
              <th scope="col" className="text-end">Total</th>
              <th scope="col" className="text-end">Active</th>
              <th scope="col" className="text-end"><abbr title="Onboarding">Onboard</abbr></th>
              <th scope="col" className="text-end">Pending</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.label}>
                <th scope="row" className="fw-medium">{row.label}</th>
                <td className="text-end">{row.total}</td>
                <td className="text-end">{row.active}</td>
                <td className="text-end">{row.onboarding}</td>
                <td className="text-end">{row.pending}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Card.Body>
  </Card>
);

export default PortfolioSummaryCard;
